import React from "react";

function HotelToken() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M33.3334 16.6667V11.6667C33.3334 9.83337 31.8334 8.33337 30 8.33337H10C8.16671 8.33337 6.66671 9.83337 6.66671 11.6667V16.6667C4.83337 16.6667 3.33337 18.1667 3.33337 20V28.3334H5.55004L6.66671 31.6667H8.33337L9.45004 28.3334H30.5667L31.6667 31.6667H33.3334L34.45 28.3334H36.6667V20C36.6667 18.1667 35.1667 16.6667 33.3334 16.6667ZM18.3334 16.6667H10V11.6667H18.3334V16.6667ZM30 16.6667H21.6667V11.6667H30V16.6667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default HotelToken;
